import { useCallback } from 'react';
import { type NavigateOptions, type To, generatePath, useNavigate } from 'react-router';

import { useMe } from '@/providers/User';

const useInstanceNavigate = () => {
  const navigate = useNavigate();
  const user = useMe();

  return useCallback(
    (to: To, options?: NavigateOptions) => {
      const instanceSlug = user?.currentOrg.instanceId.replace(/^inst:/, '');

      if (typeof to === 'string') {
        return navigate(generatePath(to, { instance: instanceSlug }), options);
      }

      return navigate(
        {
          ...to,
          pathname: to.pathname ? generatePath(to.pathname, { instance: instanceSlug }) : undefined,
        },
        options,
      );
    },
    [navigate, user],
  );
};

export default useInstanceNavigate;
